import { Trans } from 'react-i18next';

import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { NfzLoginLink } from './NfzLoginLink';

export const dispatchEwusPasswordExpiredSnackbarEvent = (): void => {
   return dispatchSnackbarNegativeEvent(
      <Trans
         i18nKey={translationKeys.euwsPasswordExpired}
         components={{
            link: <NfzLoginLink />,
         }}
      />,
      {
         autoHideDelayInMs: false,
      }
   );
};
